export default "__VITE_ASSET__DJ$x69ge__"